export function EmptyRenderer() {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-muted-foreground/60">
      <span className="text-sm">No content</span>
    </div>
  );
}
